import React, { memo, useCallback, useEffect, useState } from 'react';
import { ProfileUser, WelcomeBanner } from '@app/common';
import { Loader } from '@app/components';
import { getUserById } from '@app/api';
import { User } from '@app/models';
import { LayoutDefault } from '@app/layouts';
import { useParams } from 'react-router-dom';
import { Card } from 'components/ui/card';

function PageUser() {
  const { id } = useParams<'id'>();
  const [pending, setPending] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  const getData = useCallback(async () => {
    try {
      if (!id) return;
      setPending(true);
      const response = await getUserById(id);
      setUser(response);
      setPending(false);
    } catch (e) {
      setPending(false);
    }
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (pending) {
    return <Loader />;
  }

  if (!user) {
    return null;
  }

  return (
    <LayoutDefault>
      <WelcomeBanner />
      {pending && (
        <div className="text-center my-4">
          <Loader />
        </div>
      )}
      <div className="grid gap-4">
        <Card>
          <ProfileUser user={user} />
        </Card>
      </div>
    </LayoutDefault>
  );
}

export default memo(PageUser);
